import { currentMonth } from 'src/utils/currentMonth';
import { Entry } from '../Entry';

const today = new Date();

function getDate(day: number) {
  const previousYear = new Date().getFullYear() - 1;
  return new Date(`${previousYear}-08-${day}`);
}

export const offlineEntriesVacation: Entry[] = [
  {
    id: 'uuid-41787',
    memo: 'Dinner at Golden Sunset',
    tagIds: ['uuid-9898'],
    amount: -42, // -15000 HUF
    date: getDate(24),
  },
  {
    id: 'uuid-25853',
    memo: 'Hotel Regina',
    tagIds: ['uuid-9898'],
    amount: -500, // -180000 HUF
    date: getDate(1),
  },
  {
    id: 'uuid-258535436775',
    memo: 'Ryanair flights',
    tagIds: ['uuid-9898'],
    amount: -208, // -75000 HUF
    date: getDate(4),
  },
  {
    id: 'uuid-53033',
    memo: 'Greek night at Jorgos Taverna',
    tagIds: ['uuid-9898'],
    amount: -6, // -2350 HUF
    date: getDate(25),
  },
  {
    id: 'uuid-82489',
    memo: 'Blue Lagoon cruise with Captain Theo',
    tagIds: ['uuid-9898'],
    amount: -64, // -23000 HUF
    date: getDate(25),
  },
  {
    id: 'uuid-88314',
    memo: 'Paxos Antipaxos boat trip',
    tagIds: ['uuid-9898'],
    amount: -69, // -25000 HUF
    date: getDate(26),
  },
];
